import {
	Component,
	Input,
	OnInit,
	ViewEncapsulation,
	OnDestroy
} from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { ICrumb } from "../breadcrumb/breadcrumb.interface";

@Component({
	selector: "rbc-hero",
	templateUrl: "./hero.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class HeroComponent implements OnInit, OnDestroy {
	@Input() image: string;
	@Input() person = false;
	@Input() imagePosition = "0% 0%";
	@Input() id: string;
	@Input() imageBottom = false;
	@Input() border = false;
	@Input() centered: boolean;
	@Input() flush = false;
	@Input() fullWidth = false;
	@Input() card = false;
	@Input() borderText: string;
	@Input() borderLink: string;
	@Input() cardPositionX: "left" | "center" | "right" = "left";
	@Input() avatarImage: string;
	@Input() avatarSize: "small" | "medium" | "large" | "xlarge" | "xxlarge" = "large";
	@Input() avatarColor: string;
	@Input() avatarText: string;
	@Input() avatarTextColor: string;
	@Input() title: string;
	@Input() subtitle: string;
	@Input() ctaIcon = "";
	@Input() ctaLink: string;
	@Input() byLine: string;
	@Input() category: string;
	@Input() categoryColor: string;
	@Input() marker: string;
	@Input() text: string;
	@Input() breadcrumb: ICrumb[];
	@Input() ctaLabel: string;
	@Input() shield: boolean;
	@Input() energyLinesImage: string;

	get chevron() {
		if (this.ctaIcon === "chevron-right") {
			return "right";
		} else if (this.ctaIcon === "chevron-up") {
			return "up";
		} else if (this.ctaIcon === "chevron-down") {
			return "down";
		} else { return null; }
	}

	get icon() {
		if (
			this.ctaIcon &&
			this.ctaIcon !== "chevron-right" &&
			this.ctaIcon !== "chevron-up" &&
			this.ctaIcon !== "chevron-down"
		) {
			return this.ctaIcon;
		} else {
			return "";
		}

	}
	constructor(private idService: IdService) { }

	ngOnInit() {
		this.avatarSize = "large";
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	bannerStyles() {
		const { image, person, imagePosition } = this;
		if (!image) {
			return;
		}

		return {
			["background-image"]: `url(${image})`,
			["background-position"]: person ? "bottom right" : imagePosition,
			["background-size"]: !person ? "cover" : null
		};
	}

	bannerClasses() {
		const {
			border,
			image,
			centered,
			imageBottom,
			borderText,
			flush,
			person
		} = this;
		return {
			"rbc-hero-keyline": border && image,
			"rbc-hero-center": centered,
			"rbc-hero-flush":
				(image && imageBottom) ||
				(border && !image && !borderText) ||
				flush,
			"rbc-hero-person": person
		};
	}
}
